import SelectMultiple from '@/components/_custom/Selector/selectMultiple/selectMultiple'
import PostCategories from '@/container/daycare/daycareProfile/newsSettings/postCategories'
import { useDialog } from '@/hooks/useDialog/useDialog'
import { GET_POST_CATEGORIES } from '@/modules/API/news/news'
import { useNotification } from '@/modules/context/NotificationContext'
import { PostCategory } from '@/types/NewsFeed'
import { useQuery } from '@apollo/client'
import { FunctionComponent, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

interface PostCategorySelectorProps {
    daycareId: number
    selectedCategories: Array<number>
    setSelectedCategoriesIds: (selectedCategories: Array<string>) => void
}

const PostCategorySelector: FunctionComponent<PostCategorySelectorProps> = ({
    daycareId,
    selectedCategories,
    setSelectedCategoriesIds
}: PostCategorySelectorProps) => {
    const { t } = useTranslation()

    const { showNotificationError } = useNotification()

    const {
        data: dataCategory,
        error,
        refetch
    } = useQuery(GET_POST_CATEGORIES, {
        variables: {
            daycareId: daycareId
        }
    })

    useEffect(() => {
        if (error) {
            showNotificationError(t('generalError'))
        }
    }, [error])

    const {
        openDialogActionItem: actionItem,
        dialog,
        reopenTrigger
    } = useDialog({
        dialogTitle: t('manageResource', { resource: t('categories') }),
        Component: PostCategories,
        props: () => ({ daycareId }),
        resourceLabel: { type: 'manageResource', label: t('categories') }
    })

    return (
        <>
            <SelectMultiple
                label={t('categories')}
                selectOptions={[
                    {
                        options: (dataCategory?.getPostCategories ?? []).map((c: PostCategory) => ({
                            value: String(c.id),
                            name: c.name
                        }))
                    }
                ]}
                selectValues={selectedCategories.map((c) => String(c))}
                setSelectValues={setSelectedCategoriesIds}
                actionItem={actionItem}
                reopenTrigger={reopenTrigger}
                onOpen={refetch}
            />
            {dialog}
        </>
    )
}

export default PostCategorySelector
